export default __webpack_public_path__ + "static/media/perfume_웹.0da1075a.jpg";